import React, { useState, useContext, useEffect } from "react";
import { Container, Button, Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { TextField } from "@mui/material";
import { connect } from "react-redux";
import { MdOutlineArrowBackIos } from "react-icons/md";
import Pagination from "@mui/material/Pagination";

import { RxCross2 } from "react-icons/rx";
import ThemeContext from "../../../../common/theme/components/contexts/themecontexts";
import "./tablebooking.scss";
import "../addressbook/css/addressmodal.scss";
import { LuClock4 } from "react-icons/lu";
import { PiCalendarCheck } from "react-icons/pi";
import { GrGroup } from "react-icons/gr";
import { ImCheckmark } from "react-icons/im";
import { FaRegCircleXmark } from "react-icons/fa6";
import img from "./noOrder.png";
// import img from "./no_booking_image.png";
import { getTableBooking } from "../../../../actions/myaccount/tablebooking/tableBookingActions";
import { getProfile } from "../../../../actions/myaccount/profile/getProfileActions";

const Tablebooking = ({
  getTableBooking,
  tableBooking,
  userData,
  profile,
  getProfile,
}) => {
  const breakpoint = 992;
  const location = useLocation();
  const [width, setWidth] = useState(window.innerWidth);
  const [current, setCurrent] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [show, setShow] = useState(false);
  const { theme } = useContext(ThemeContext);
  const handleClose = () => setShow(false);
  const tableBookingData = tableBooking?.message || [];
  const [filter, setFilter] = useState("All");
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    if (tableBookingData?.length) {
      const filteredData = Array.isArray(tableBookingData)
        ? tableBookingData.filter((booking) => {
            const currentDateTimeInSeconds = Math.floor(
              new Date().getTime() / 1000
            );

            const bookingDate = new Date(booking.table);
            let [time, period] = booking.time.split(" ");
            let [hours, minutes] = time.split(":").map(Number);

            // Convert to 24-hour format
            if (period === "PM" && hours !== 12) hours += 12;
            if (period === "AM" && hours === 12) hours = 0;

            // Set the parsed 24-hour time to bookingDate
            bookingDate.setHours(hours, minutes, 0);

            // Convert bookingDateTime to seconds
            const bookingDateTimeInSeconds = Math.floor(
              bookingDate.getTime() / 1000
            );

            switch (filter) {
              case "Upcoming":
                return (
                  bookingDateTimeInSeconds > currentDateTimeInSeconds &&
                  booking.order_status === "Accepted"
                );
              case "Past":
                return (
                  bookingDateTimeInSeconds < currentDateTimeInSeconds &&
                  booking.order_status === "Accepted"
                );
              case "Confirmation":
                return booking.order_status === "Placed";
              case "Cancelled":
                return booking.order_status === "Rejected";
              default:
                return true;
            }
          })
        : [];

      setFilteredBookings(filteredData);
    }
  }, [filter, tableBookingData]);

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 6;
  const totalPages = Math.ceil(filteredBookings.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentBookings = filteredBookings.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const handleShow = (modalContent, booking) => {
    setCurrent(modalContent);
    setSelectedBooking(booking);
    setShow(true);
  };
  const navigate = useNavigate();

  const handlemyaccountclick = () => {
    setShow(false);
  };
  const handleCancelModel = () => {
    setShow(false);
  };

  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  useEffect(() => {
    if (userData && userData?.customerId) {
      getProfile({
        customer_id: userData?.customerId,
        domain: window.location.hostname,
        body: "Your body",
      });
    }
  }, [getProfile, userData]);

  const navigateto = useNavigate();
  if (!location.pathname?.includes("/myaccount") && width > breakpoint) {
    navigateto("/myaccount/tablebooking");
  }
  const getStatusTextt = (status) => {
    switch (status) {
      case "Accepted":
        return (
          <Button
            className="confirmed-btn"
            style={{
              backgroundColor: "#9bff6b",
              color: "green",
              border: "1px solid green",
            }}
          >
            <ImCheckmark className="imagefor-text" fill="green" />
            <span> Accepted</span>
          </Button>
        );
      case "review":
        return (
          <Button
            style={{ backgroundColor: "#ffcbcb" }}
            className="imagefor-textrevieww"
            onClick={() => handleShow("Reviewmodal")}
          >
            <img
              src="https://fusionbucket.co.uk/My-account/reviewicon.png"
              alt="review-icon"
              className="imagefor-textreview"
            />
            <span> Review</span>
          </Button>
        );
      case "Rejected":
        return (
          <Button
            className="reject-btn"
            variant="danger"
            style={{ backgroundColor: "#ffcbcb", color: "red" }}
          >
            <FaRegCircleXmark
              fill="red"
              size="25px"
              className="imagefor-textcancel"
            />
            <span> Rejected</span>
          </Button>
        );
      case "Placed":
        return (
          <Button
            style={{ backgroundColor: "#ffe677", color: "warning" }}
            className="waiting-text"
            variant="warning"
          >
            <img
              src="https://fusionbucket.co.uk/My-account/fi_66163.png"
              alt="tick-icon"
              className="imagefor-text"
            />
            <span>Waiting for Confirmation</span>
          </Button>
        );
      default:
        return null;
    }
  };
  const Modalcontenttable = ({ booking }) => (
    <>
      <div className="tablemodalbooking-op">
        <h5
          className="tablebooking-arrow"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>Manage My Booking</div>
          <div>
            <RxCross2
              onClick={handlemyaccountclick}
              style={{
                margin: "0px 10px",
                backgroundColor: "red",
                borderRadius: "20px",
                padding: "5px",
              }}
            />
          </div>
        </h5>
        <div className="modalbooking-manage p-0" style={{ boxShadow: "none" }}>
          <p className="textjaliso align-items-center justify-content-between">
            <p className="mb-0">{booking.restaurant_details.takeaway_name}</p>
            <p className="text-cardbox">
              {getStatusTextt(booking?.order_status)}
            </p>
          </p>
          <div className="modal-footertexttable">
            <div className="calender-div">
              <PiCalendarCheck
                style={{ margin: "3px 4px 5px 3px" }}
                className="model-tableBookingImage"
              />
              <span className="model-responseDatetime">{booking.table}</span>
            </div>
            <div className="model-responseTimeDiv">
              <LuClock4 className="model-responseTime" />
              <span style={{ margin: "5px" }}>{booking.time}</span>
            </div>
            <div className="model-responseGuestDiv">
              <GrGroup className="model-responseGuest" />
              <span style={{ margin: "0px 0px 0px 4px" }}>
                {booking?.people}
              </span>
            </div>
            {/* {booking?.discount === 0 &&
                            <div className='model-discount-text' >{booking?.discount}%</div>} */}
            {booking?.discount !== 0 && (
              <div
                className="model-discount-text"
                style={{
                  visibility: booking?.discount === 0 ? "hidden" : "visible",
                }}
              >
                {booking?.discount}%
              </div>
            )}
          </div>
          <p className="button-optionstablebookingmodal">
            <Button className="button-callrestaurant">
              <a
                href={`tel:${booking.restaurant_details.business_phone}`}
                style={{ textDecoration: "none" }}
              >
                Call Restaurant
              </a>
            </Button>

            <Button onClick={handleCancelModel} className="button-cancelmodal">
              Cancel
            </Button>
          </p>
        </div>
      </div>
    </>
  );
  const Reviewmodal = () => (
    <>
      <h4>Leave As A Review </h4>
      <TextField
        multiline
        rows={3}
        placeholder="Type Your Message Here..."
        fullWidth
        className="textfeild-review"
      />
      <Button className="Button-review"> Submit </Button>
    </>
  );
  const CustomTableCard = ({ booking }) => {
    const getStatusText = (status) => {
      switch (status) {
        case "Accepted":
          return (
            <span className="confirmed-text">
              <ImCheckmark className="imagefor-text" fill="green" />
              <span> Accepted</span>
            </span>
          );
        case "review":
          return (
            <span
              className="imagefor-textreview"
              onClick={() => handleShow("Reviewmodal")}
            >
              <img
                src="https://fusionbucket.co.uk/My-account/reviewicon.png"
                alt="review-icon"
                className="imagefor-textreview"
              />
              <span> Review</span>
            </span>
          );
        case "Rejected":
          return (
            <span className="imagefor-textcancel">
              <FaRegCircleXmark
                fill="red"
                size="25px"
                className="imagefor-textcancel"
              />
              <span> Rejected</span>
            </span>
          );
        case "Placed":
          return (
            <span className="waiting-text">
              <img
                src="https://fusionbucket.co.uk/My-account/fi_66163.png"
                alt="tick-icon"
                className="imagefor-text"
              />
              <span>Waiting for Confirmation</span>
            </span>
          );
        default:
          return null;
      }
    };

    return (
      <div className="custom-tablecard">
        <div className="custom-cardttable">
          <img
            src={booking.logo}
            alt={"tablebooking"}
            className="image-tablebooking"
            onClick={() => handleShow("Modalcontenttable", booking)}
          />
          <div className="table-data">
            <p className="text-cardbox">
              {booking?.restaurant_details.takeaway_name}
            </p>
            <p className="text-cardbox">
              <span>
                <img
                  src="https://fusionbucket.co.uk/My-account/mexican foodicon.png"
                  alt="cuisine-icon"
                  className="imagefor-text"
                />
                <span className="cusines">{booking?.cousines[0]}</span>
              </span>
            </p>
            <p className="text-cardbox">
              {getStatusText(booking?.order_status)}
            </p>
          </div>
        </div>
        <div className="footer-texttable">
          <PiCalendarCheck className="tableBookingImage" />
          <span className="responseDatetime">{booking?.table}</span>
          <div className="responseTimeDiv">
            <LuClock4 className="responseTime" />
            <span style={{ margin: "5px" }}>{booking?.time}</span>
          </div>
          <div className="responseGuestDiv">
            <GrGroup className="responseGuest" />
            <span style={{ margin: "0px 0px 0px 4px" }}>{booking?.people}</span>
          </div>
          <div
            className="model-discount-text"
            style={{
              visibility: booking?.discount === 0 ? "hidden" : "visible",
            }}
          >
            {booking?.discount} %
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setLoading(true);
    if (profile?.data?.profile?.email && userData?.customerId) {
      try {
        getTableBooking({
          customer_id: userData?.customerId,
          email: profile?.data?.profile?.email,
        });
      } catch (error) {
        console.error("Error fetching table booking data:", error);
      } finally {
        setLoading(false);
      }
    }
  }, [profile, currentPage, userData?.customerId, getTableBooking]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    setFilter(filter);
  };

  return (
    <section>
      {width > breakpoint ? (
        <>
          <div className="yourorder-fk">
            <Container>
              <div>
                <h5 className="tablebooking-arrow">
                  {/* <MdOutlineArrowBackIos className='arrowtop-tablebk' onClick={() => navigate('/myaccount')} /> */}
                  Table Booking
                </h5>
              </div>
              <p className="button-optionstablebookingdesktop">
                {tableBooking?.message?.length < 2 ? (
                  <Button
                    className="button-all text-nowrap"
                    onClick={() => setFilter("All")}
                  >
                    All
                  </Button>
                ) : (
                  <>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "All" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("All")}
                    >
                      All
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Upcoming" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Upcoming")}
                    >
                      Upcoming
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Past" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Past")}
                    >
                      Past Bookings
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Cancelled" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Cancelled")}
                    >
                      Cancelled
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Confirmation" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Confirmation")}
                    >
                      Confirmation
                    </Button>
                  </>
                )}
              </p>
              <div className="row">
                {currentBookings &&
                Array.isArray(currentBookings) &&
                currentBookings?.length > 0 ? (
                  currentBookings.map((booking) => (
                    <div className="col-6" key={booking?.id}>
                      <CustomTableCard booking={booking} />
                    </div>
                  ))
                ) : (
                  <div className="no-favourites mt-3 d-flex flex-column gap-3">
                    <img
                      src={img}
                      alt="No favourites"
                      style={{ width: "100px" }}
                    />
                    <div className="div">
                      <h5>No Booking Available!</h5>
                      <button onClick={() => navigate("/list")}>Menu</button>
                    </div>
                  </div>
                )}
              </div>
              {/* {totalPages > 1 && (
                                <div className="pagination">
                                    <button onClick={handlePreviousPage} disabled={currentPage === 1}>Previous</button>
                                    <span> {currentPage} </span>...<span>{totalPages}</span>
                                    <button onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
                                </div>
                            )} */}

              {totalPages > 1 ? (
                <div className="d-flex justify-content-end pagniation_mui">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    size="large"
                    onChange={(e, v) => {
                      setCurrentPage(v);
                    }}
                    variant="outlined"
                    shape="rounded"
                  />
                </div>
              ) : null}
            </Container>
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="bottom-modaladdress"
              className={theme === "dark" ? "dark-popup" : null}
            >
              <Modal.Body>
                {current === "Modalcontenttable" && selectedBooking && (
                  <Modalcontenttable booking={selectedBooking} />
                )}
                {current === "Reviewmodal" && <Reviewmodal />}
              </Modal.Body>
            </Modal>
          </div>
        </>
      ) : (
        <>
          <div className="yourorder-fk">
            <Container>
              <div>
                <h5 className="tablebooking-arrow d-none">
                  <MdOutlineArrowBackIos
                    className=" arrowtop-tablebk"
                    onClick={() => navigate("/myaccount")}
                  />
                  Table Booking
                </h5>
              </div>
              <p className="button-optionstablebookingdesktop mt-4">
                {tableBooking?.message?.length < 2 ? (
                  <Button
                    className="button-all text-nowrap"
                    onClick={() => setFilter("All")}
                  >
                    All
                  </Button>
                ) : (
                  <>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "All" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("All")}
                    >
                      All
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Upcoming" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Upcoming")}
                    >
                      Upcoming
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Past" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Past")}
                    >
                      Past Bookings
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Cancelled" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Cancelled")}
                    >
                      Cancelled
                    </Button>
                    <Button
                      className={`button-all text-nowrap ${
                        activeFilter === "Confirmation" ? "active-button" : ""
                      }`}
                      onClick={() => handleFilterChange("Confirmation")}
                    >
                      Confirmation
                    </Button>
                  </>
                )}
              </p>
              {currentBookings &&
              Array.isArray(currentBookings) &&
              currentBookings.length > 0 ? (
                currentBookings.map((booking) => (
                  <CustomTableCard key={booking.id} booking={booking} />
                ))
              ) : (
                <>
                  <div className="no-favourites mt-4 d-flex flex-column  ">
                    <div className="d-flex justify-content-center w-100">
                      <img
                        src={img}
                        alt="No favourites"
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div className="div">
                      <h5 className="menutext">No Booking Available!</h5>
                      <div className="menudevbutton">
                        <button
                          className="menubutton"
                          onClick={() => navigate("/list")}
                        >
                          Menu
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {/* {totalPages > 1 && (
                <div className="pagination">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <span> {currentPage} </span>...<span>{totalPages}</span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )} */}
              {totalPages > 1 ? (
                <div className="d-flex justify-content-end pagniation_mui">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    size="large"
                    onChange={(e, v) => {
                      setCurrentPage(v);
                    }}
                    variant="outlined"
                    shape="rounded"
                  />
                </div>
              ) : null}
            </Container>
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="bottom-modaladdress"
              className={theme === "dark" ? "dark-popup" : null}
            >
              <Modal.Body>
                {current === "Modalcontenttable" && selectedBooking && (
                  <Modalcontenttable booking={selectedBooking} />
                )}
                {current === "Reviewmodal" && <Reviewmodal />}
              </Modal.Body>
            </Modal>
          </div>
        </>
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  tableBooking: state.tableBooking.tableBooking,
  userData: state.userdata.userData,
  profile: state.profile.profile,
});
const mapDispatchToProps = {
  getTableBooking,
  getProfile,
};
export default connect(mapStateToProps, mapDispatchToProps)(Tablebooking);
